import {auth} from '@/api-services'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useAuthStore = defineStore('authStore', {
  state: () => ({
    user: {},
    loading: false,
    isEmailSentSuccess: false,
    isPasswordChangeSuccess: false,
    isLoginSuccess: false,
    error: null,
  }),
  getters: {
    logout() {
      window.$cookies.remove('auth')
      window.location.replace('/SignIn')
    },
  },
  actions: {
    async getAuthUser() {
      this.loading = true
      try {
        if (window.$cookies.get('auth')) {
          const response = await auth.getUser()
          const data = await response.data
          this.user = data
        } else {
          this.user=null
        }
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async login(payload) {
      this.loading = true
      try {
        const response = await auth.userLogin(payload)
        this.isLoginSuccess = true
        window.$cookies.set('auth', await response.data)
        toast.success(successHandler('LOGGED_IN_MESSAGE'))
    } catch (error) {
      if (error.length > 0) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } else {
        const errorMsg = errorHandler(error.response.data.error)
          this.error = errorMsg
          toast.error(errorMsg)
      }
    } finally {
      this.loading = false
    }
  },

    async resetPassword(payload) {
      this.loading = true
      try {
        await auth.postResetPassword(payload)
        this.isEmailSentSuccess = true
        toast.success(successHandler('RESET_PASSWORD_LINK_SUCCESS'))
    } catch (error) {
      if (error.length > 0) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } else {
        const errorMsg = errorHandler(error.response.data.error)
          this.error = errorMsg
          toast.error(errorMsg)
      }
    } finally {
      this.loading = false
    }
  },

  async resendConfirmation(payload) {
    this.loading = true
    try {
      await auth.resendConfirmation(payload)
      this.isEmailSentSuccess = true
      toast.success(successHandler('RESEND_CONFIRMATION_LINK_SUCCESS'))
  } catch (error) {
    error.map((e) => {
      const errorMsg = errorHandler(e)
      this.error = errorMsg
      toast.error(errorMsg)
    })
  } finally {
    this.loading = false
  }
},

  async changePassword(payload) {
    this.loading = true
    try {
      await auth.changePassword(payload)
      window.$cookies.remove('auth')
      this.isPasswordChangeSuccess = true
      toast.success(successHandler('CHANGE_PASSWORD_SUCCESS'))
  } catch (error) {
    error.map((e) => {
      const errorMsg = errorHandler(e)
      this.error = errorMsg
      toast.error(errorMsg)
    })
  } finally {
    this.loading = false
  }
},
  },
})
